export type SearchParamsType = {
  pageNumber: number;
  pageSize: number;
  searchText: string;
  sortField: string;
  sortOrder: string;
  status: number;
};

export type MasterTableDataType = {
  diseaseId: number;
  diseaseClinicId: number;
  diseaseCode: string;
  diseaseStatus: number;
  diseaseName: string;
  diseaseCreatedById: number;
  diseaseCreatedByDate: string;
};

export type MasterDataType = {
  diseaseId: number;
  diseaseClinicId: number;
  diseaseCode: string;
  diseaseName: string;
  diseaseStatus: number;
  diseaseCreatedById: number;
};

export type SaveResponseType = {};

export type MasterFormDataType = {
  diseaseCode: string;
  diseaseName: string;
  diseaseStatus: number;
};

export const initialFormData: MasterFormDataType = {
  diseaseCode: "",
  diseaseName: "",
  diseaseStatus: 1,
};
